/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MinimalRouteImport } from './routes/_minimal'
import { Route as MainRouteImport } from './routes/_main'
import { Route as MainIndexRouteImport } from './routes/_main/index'
import { Route as MinimalInfoRouteImport } from './routes/_minimal/info'
import { Route as MainListRouteImport } from './routes/_main/_list'
import { Route as MainFormRouteImport } from './routes/_main/_form'
import { Route as MainDetailsRouteImport } from './routes/_main/_details'
import { Route as MinimalInvitationsInvitationTokenRouteImport } from './routes/_minimal/invitations.$invitationToken'
import { Route as MainListProgramsIndexRouteImport } from './routes/_main/_list/programs/index'
import { Route as MainListMetricsIndexRouteImport } from './routes/_main/_list/metrics/index'
import { Route as MainListCampaignsIndexRouteImport } from './routes/_main/_list/campaigns/index'
import { Route as MainListApiKeysIndexRouteImport } from './routes/_main/_list/api-keys/index'
import { Route as MainListActivityIndexRouteImport } from './routes/_main/_list/activity/index'
import { Route as MainFormSettingsIndexRouteImport } from './routes/_main/_form/settings/index'
import { Route as MainListCampaignsArchiveRouteImport } from './routes/_main/_list/campaigns/archive'
import { Route as MainDetailsProgramsProgramIdRouteImport } from './routes/_main/_details/programs/$programId'
import { Route as MainDetailsCampaignsCampaignIdRouteImport } from './routes/_main/_details/campaigns/$campaignId'
import { Route as MainFormProgramsCreateIndexRouteImport } from './routes/_main/_form/programs/create/index'
import { Route as MainFormCampaignsCreateIndexRouteImport } from './routes/_main/_form/campaigns/create/index'
import { Route as MainDetailsInviteGuideIndexRouteImport } from './routes/_main/_details/invite/guide/index'
import { Route as MainDetailsApiKeysGuideIndexRouteImport } from './routes/_main/_details/api-keys/guide/index'
import { Route as MainListProgramsProgramIdCampaignsRouteImport } from './routes/_main/_list/programs/$programId.campaigns'
import { Route as MainListProgramsProgramIdActivityRouteImport } from './routes/_main/_list/programs/$programId.activity'
import { Route as MainListCampaignsCampaignIdEditRequestsRouteImport } from './routes/_main/_list/campaigns/$campaignId.edit-requests'
import { Route as MainListCampaignsCampaignIdActivityRouteImport } from './routes/_main/_list/campaigns/$campaignId.activity'
import { Route as MainFormProgramsProgramIdEditIndexRouteImport } from './routes/_main/_form/programs/$programId.edit/index'
import { Route as MainFormCampaignsDuplicateCampaignIdIndexRouteImport } from './routes/_main/_form/campaigns/duplicate.$campaignId/index'
import { Route as MainFormCampaignsDraftCampaignIdIndexRouteImport } from './routes/_main/_form/campaigns/draft.$campaignId/index'
import { Route as MainFormCampaignsCampaignIdEditIndexRouteImport } from './routes/_main/_form/campaigns/$campaignId.edit/index'
import { Route as MainDetailsCampaignsEditGuideIndexRouteImport } from './routes/_main/_details/campaigns/edit/guide/index'
import { Route as MainDetailsCampaignsCreateGuideIndexRouteImport } from './routes/_main/_details/campaigns/create/guide/index'
import { Route as MainDetailsCampaignsArchiveGuideIndexRouteImport } from './routes/_main/_details/campaigns/archive/guide/index'
import { Route as MainFormCampaignsCampaignIdEditRequestRouteImport } from './routes/_main/_form/campaigns/$campaignId.edit/request'

const MinimalRoute = MinimalRouteImport.update({
  id: '/_minimal',
  getParentRoute: () => rootRouteImport,
} as any)
const MainRoute = MainRouteImport.update({
  id: '/_main',
  getParentRoute: () => rootRouteImport,
} as any)
const MainIndexRoute = MainIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainRoute,
} as any)
const MinimalInfoRoute = MinimalInfoRouteImport.update({
  id: '/info',
  path: '/info',
  getParentRoute: () => MinimalRoute,
} as any)
const MainListRoute = MainListRouteImport.update({
  id: '/_list',
  getParentRoute: () => MainRoute,
} as any)
const MainFormRoute = MainFormRouteImport.update({
  id: '/_form',
  getParentRoute: () => MainRoute,
} as any)
const MainDetailsRoute = MainDetailsRouteImport.update({
  id: '/_details',
  getParentRoute: () => MainRoute,
} as any)
const MinimalInvitationsInvitationTokenRoute =
  MinimalInvitationsInvitationTokenRouteImport.update({
    id: '/invitations/$invitationToken',
    path: '/invitations/$invitationToken',
    getParentRoute: () => MinimalRoute,
  } as any)
const MainListProgramsIndexRoute = MainListProgramsIndexRouteImport.update({
  id: '/programs/',
  path: '/programs/',
  getParentRoute: () => MainListRoute,
} as any)
const MainListMetricsIndexRoute = MainListMetricsIndexRouteImport.update({
  id: '/metrics/',
  path: '/metrics/',
  getParentRoute: () => MainListRoute,
} as any)
const MainListCampaignsIndexRoute = MainListCampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => MainListRoute,
} as any)
const MainListApiKeysIndexRoute = MainListApiKeysIndexRouteImport.update({
  id: '/api-keys/',
  path: '/api-keys/',
  getParentRoute: () => MainListRoute,
} as any)
const MainListActivityIndexRoute = MainListActivityIndexRouteImport.update({
  id: '/activity/',
  path: '/activity/',
  getParentRoute: () => MainListRoute,
} as any)
const MainFormSettingsIndexRoute = MainFormSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => MainFormRoute,
} as any)
const MainListCampaignsArchiveRoute =
  MainListCampaignsArchiveRouteImport.update({
    id: '/campaigns/archive',
    path: '/campaigns/archive',
    getParentRoute: () => MainListRoute,
  } as any)
const MainDetailsProgramsProgramIdRoute =
  MainDetailsProgramsProgramIdRouteImport.update({
    id: '/programs/$programId',
    path: '/programs/$programId',
    getParentRoute: () => MainDetailsRoute,
  } as any)
const MainDetailsCampaignsCampaignIdRoute =
  MainDetailsCampaignsCampaignIdRouteImport.update({
    id: '/campaigns/$campaignId',
    path: '/campaigns/$campaignId',
    getParentRoute: () => MainDetailsRoute,
  } as any)
const MainFormProgramsCreateIndexRoute =
  MainFormProgramsCreateIndexRouteImport.update({
    id: '/programs/create/',
    path: '/programs/create/',
    getParentRoute: () => MainFormRoute,
  } as any)
const MainFormCampaignsCreateIndexRoute =
  MainFormCampaignsCreateIndexRouteImport.update({
    id: '/campaigns/create/',
    path: '/campaigns/create/',
    getParentRoute: () => MainFormRoute,
  } as any)
const MainDetailsInviteGuideIndexRoute =
  MainDetailsInviteGuideIndexRouteImport.update({
    id: '/invite/guide/',
    path: '/invite/guide/',
    getParentRoute: () => MainDetailsRoute,
  } as any)
const MainDetailsApiKeysGuideIndexRoute =
  MainDetailsApiKeysGuideIndexRouteImport.update({
    id: '/api-keys/guide/',
    path: '/api-keys/guide/',
    getParentRoute: () => MainDetailsRoute,
  } as any)
const MainListProgramsProgramIdCampaignsRoute =
  MainListProgramsProgramIdCampaignsRouteImport.update({
    id: '/programs/$programId/campaigns',
    path: '/programs/$programId/campaigns',
    getParentRoute: () => MainListRoute,
  } as any)
const MainListProgramsProgramIdActivityRoute =
  MainListProgramsProgramIdActivityRouteImport.update({
    id: '/programs/$programId/activity',
    path: '/programs/$programId/activity',
    getParentRoute: () => MainListRoute,
  } as any)
const MainListCampaignsCampaignIdEditRequestsRoute =
  MainListCampaignsCampaignIdEditRequestsRouteImport.update({
    id: '/campaigns/$campaignId/edit-requests',
    path: '/campaigns/$campaignId/edit-requests',
    getParentRoute: () => MainListRoute,
  } as any)
const MainListCampaignsCampaignIdActivityRoute =
  MainListCampaignsCampaignIdActivityRouteImport.update({
    id: '/campaigns/$campaignId/activity',
    path: '/campaigns/$campaignId/activity',
    getParentRoute: () => MainListRoute,
  } as any)
const MainFormProgramsProgramIdEditIndexRoute =
  MainFormProgramsProgramIdEditIndexRouteImport.update({
    id: '/programs/$programId/edit/',
    path: '/programs/$programId/edit/',
    getParentRoute: () => MainFormRoute,
  } as any)
const MainFormCampaignsDuplicateCampaignIdIndexRoute =
  MainFormCampaignsDuplicateCampaignIdIndexRouteImport.update({
    id: '/campaigns/duplicate/$campaignId/',
    path: '/campaigns/duplicate/$campaignId/',
    getParentRoute: () => MainFormRoute,
  } as any)
const MainFormCampaignsDraftCampaignIdIndexRoute =
  MainFormCampaignsDraftCampaignIdIndexRouteImport.update({
    id: '/campaigns/draft/$campaignId/',
    path: '/campaigns/draft/$campaignId/',
    getParentRoute: () => MainFormRoute,
  } as any)
const MainFormCampaignsCampaignIdEditIndexRoute =
  MainFormCampaignsCampaignIdEditIndexRouteImport.update({
    id: '/campaigns/$campaignId/edit/',
    path: '/campaigns/$campaignId/edit/',
    getParentRoute: () => MainFormRoute,
  } as any)
const MainDetailsCampaignsEditGuideIndexRoute =
  MainDetailsCampaignsEditGuideIndexRouteImport.update({
    id: '/campaigns/edit/guide/',
    path: '/campaigns/edit/guide/',
    getParentRoute: () => MainDetailsRoute,
  } as any)
const MainDetailsCampaignsCreateGuideIndexRoute =
  MainDetailsCampaignsCreateGuideIndexRouteImport.update({
    id: '/campaigns/create/guide/',
    path: '/campaigns/create/guide/',
    getParentRoute: () => MainDetailsRoute,
  } as any)
const MainDetailsCampaignsArchiveGuideIndexRoute =
  MainDetailsCampaignsArchiveGuideIndexRouteImport.update({
    id: '/campaigns/archive/guide/',
    path: '/campaigns/archive/guide/',
    getParentRoute: () => MainDetailsRoute,
  } as any)
const MainFormCampaignsCampaignIdEditRequestRoute =
  MainFormCampaignsCampaignIdEditRequestRouteImport.update({
    id: '/campaigns/$campaignId/edit/request',
    path: '/campaigns/$campaignId/edit/request',
    getParentRoute: () => MainFormRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/info': typeof MinimalInfoRoute
  '/': typeof MainIndexRoute
  '/invitations/$invitationToken': typeof MinimalInvitationsInvitationTokenRoute
  '/campaigns/$campaignId': typeof MainDetailsCampaignsCampaignIdRoute
  '/programs/$programId': typeof MainDetailsProgramsProgramIdRoute
  '/campaigns/archive': typeof MainListCampaignsArchiveRoute
  '/settings': typeof MainFormSettingsIndexRoute
  '/activity': typeof MainListActivityIndexRoute
  '/api-keys': typeof MainListApiKeysIndexRoute
  '/campaigns': typeof MainListCampaignsIndexRoute
  '/metrics': typeof MainListMetricsIndexRoute
  '/programs': typeof MainListProgramsIndexRoute
  '/campaigns/$campaignId/activity': typeof MainListCampaignsCampaignIdActivityRoute
  '/campaigns/$campaignId/edit-requests': typeof MainListCampaignsCampaignIdEditRequestsRoute
  '/programs/$programId/activity': typeof MainListProgramsProgramIdActivityRoute
  '/programs/$programId/campaigns': typeof MainListProgramsProgramIdCampaignsRoute
  '/api-keys/guide': typeof MainDetailsApiKeysGuideIndexRoute
  '/invite/guide': typeof MainDetailsInviteGuideIndexRoute
  '/campaigns/create': typeof MainFormCampaignsCreateIndexRoute
  '/programs/create': typeof MainFormProgramsCreateIndexRoute
  '/campaigns/$campaignId/edit/request': typeof MainFormCampaignsCampaignIdEditRequestRoute
  '/campaigns/archive/guide': typeof MainDetailsCampaignsArchiveGuideIndexRoute
  '/campaigns/create/guide': typeof MainDetailsCampaignsCreateGuideIndexRoute
  '/campaigns/edit/guide': typeof MainDetailsCampaignsEditGuideIndexRoute
  '/campaigns/$campaignId/edit': typeof MainFormCampaignsCampaignIdEditIndexRoute
  '/campaigns/draft/$campaignId': typeof MainFormCampaignsDraftCampaignIdIndexRoute
  '/campaigns/duplicate/$campaignId': typeof MainFormCampaignsDuplicateCampaignIdIndexRoute
  '/programs/$programId/edit': typeof MainFormProgramsProgramIdEditIndexRoute
}
export interface FileRoutesByTo {
  '/info': typeof MinimalInfoRoute
  '/': typeof MainIndexRoute
  '/invitations/$invitationToken': typeof MinimalInvitationsInvitationTokenRoute
  '/campaigns/$campaignId': typeof MainDetailsCampaignsCampaignIdRoute
  '/programs/$programId': typeof MainDetailsProgramsProgramIdRoute
  '/campaigns/archive': typeof MainListCampaignsArchiveRoute
  '/settings': typeof MainFormSettingsIndexRoute
  '/activity': typeof MainListActivityIndexRoute
  '/api-keys': typeof MainListApiKeysIndexRoute
  '/campaigns': typeof MainListCampaignsIndexRoute
  '/metrics': typeof MainListMetricsIndexRoute
  '/programs': typeof MainListProgramsIndexRoute
  '/campaigns/$campaignId/activity': typeof MainListCampaignsCampaignIdActivityRoute
  '/campaigns/$campaignId/edit-requests': typeof MainListCampaignsCampaignIdEditRequestsRoute
  '/programs/$programId/activity': typeof MainListProgramsProgramIdActivityRoute
  '/programs/$programId/campaigns': typeof MainListProgramsProgramIdCampaignsRoute
  '/api-keys/guide': typeof MainDetailsApiKeysGuideIndexRoute
  '/invite/guide': typeof MainDetailsInviteGuideIndexRoute
  '/campaigns/create': typeof MainFormCampaignsCreateIndexRoute
  '/programs/create': typeof MainFormProgramsCreateIndexRoute
  '/campaigns/$campaignId/edit/request': typeof MainFormCampaignsCampaignIdEditRequestRoute
  '/campaigns/archive/guide': typeof MainDetailsCampaignsArchiveGuideIndexRoute
  '/campaigns/create/guide': typeof MainDetailsCampaignsCreateGuideIndexRoute
  '/campaigns/edit/guide': typeof MainDetailsCampaignsEditGuideIndexRoute
  '/campaigns/$campaignId/edit': typeof MainFormCampaignsCampaignIdEditIndexRoute
  '/campaigns/draft/$campaignId': typeof MainFormCampaignsDraftCampaignIdIndexRoute
  '/campaigns/duplicate/$campaignId': typeof MainFormCampaignsDuplicateCampaignIdIndexRoute
  '/programs/$programId/edit': typeof MainFormProgramsProgramIdEditIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_main': typeof MainRouteWithChildren
  '/_minimal': typeof MinimalRouteWithChildren
  '/_main/_details': typeof MainDetailsRouteWithChildren
  '/_main/_form': typeof MainFormRouteWithChildren
  '/_main/_list': typeof MainListRouteWithChildren
  '/_minimal/info': typeof MinimalInfoRoute
  '/_main/': typeof MainIndexRoute
  '/_minimal/invitations/$invitationToken': typeof MinimalInvitationsInvitationTokenRoute
  '/_main/_details/campaigns/$campaignId': typeof MainDetailsCampaignsCampaignIdRoute
  '/_main/_details/programs/$programId': typeof MainDetailsProgramsProgramIdRoute
  '/_main/_list/campaigns/archive': typeof MainListCampaignsArchiveRoute
  '/_main/_form/settings/': typeof MainFormSettingsIndexRoute
  '/_main/_list/activity/': typeof MainListActivityIndexRoute
  '/_main/_list/api-keys/': typeof MainListApiKeysIndexRoute
  '/_main/_list/campaigns/': typeof MainListCampaignsIndexRoute
  '/_main/_list/metrics/': typeof MainListMetricsIndexRoute
  '/_main/_list/programs/': typeof MainListProgramsIndexRoute
  '/_main/_list/campaigns/$campaignId/activity': typeof MainListCampaignsCampaignIdActivityRoute
  '/_main/_list/campaigns/$campaignId/edit-requests': typeof MainListCampaignsCampaignIdEditRequestsRoute
  '/_main/_list/programs/$programId/activity': typeof MainListProgramsProgramIdActivityRoute
  '/_main/_list/programs/$programId/campaigns': typeof MainListProgramsProgramIdCampaignsRoute
  '/_main/_details/api-keys/guide/': typeof MainDetailsApiKeysGuideIndexRoute
  '/_main/_details/invite/guide/': typeof MainDetailsInviteGuideIndexRoute
  '/_main/_form/campaigns/create/': typeof MainFormCampaignsCreateIndexRoute
  '/_main/_form/programs/create/': typeof MainFormProgramsCreateIndexRoute
  '/_main/_form/campaigns/$campaignId/edit/request': typeof MainFormCampaignsCampaignIdEditRequestRoute
  '/_main/_details/campaigns/archive/guide/': typeof MainDetailsCampaignsArchiveGuideIndexRoute
  '/_main/_details/campaigns/create/guide/': typeof MainDetailsCampaignsCreateGuideIndexRoute
  '/_main/_details/campaigns/edit/guide/': typeof MainDetailsCampaignsEditGuideIndexRoute
  '/_main/_form/campaigns/$campaignId/edit/': typeof MainFormCampaignsCampaignIdEditIndexRoute
  '/_main/_form/campaigns/draft/$campaignId/': typeof MainFormCampaignsDraftCampaignIdIndexRoute
  '/_main/_form/campaigns/duplicate/$campaignId/': typeof MainFormCampaignsDuplicateCampaignIdIndexRoute
  '/_main/_form/programs/$programId/edit/': typeof MainFormProgramsProgramIdEditIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/info'
    | '/'
    | '/invitations/$invitationToken'
    | '/campaigns/$campaignId'
    | '/programs/$programId'
    | '/campaigns/archive'
    | '/settings'
    | '/activity'
    | '/api-keys'
    | '/campaigns'
    | '/metrics'
    | '/programs'
    | '/campaigns/$campaignId/activity'
    | '/campaigns/$campaignId/edit-requests'
    | '/programs/$programId/activity'
    | '/programs/$programId/campaigns'
    | '/api-keys/guide'
    | '/invite/guide'
    | '/campaigns/create'
    | '/programs/create'
    | '/campaigns/$campaignId/edit/request'
    | '/campaigns/archive/guide'
    | '/campaigns/create/guide'
    | '/campaigns/edit/guide'
    | '/campaigns/$campaignId/edit'
    | '/campaigns/draft/$campaignId'
    | '/campaigns/duplicate/$campaignId'
    | '/programs/$programId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/info'
    | '/'
    | '/invitations/$invitationToken'
    | '/campaigns/$campaignId'
    | '/programs/$programId'
    | '/campaigns/archive'
    | '/settings'
    | '/activity'
    | '/api-keys'
    | '/campaigns'
    | '/metrics'
    | '/programs'
    | '/campaigns/$campaignId/activity'
    | '/campaigns/$campaignId/edit-requests'
    | '/programs/$programId/activity'
    | '/programs/$programId/campaigns'
    | '/api-keys/guide'
    | '/invite/guide'
    | '/campaigns/create'
    | '/programs/create'
    | '/campaigns/$campaignId/edit/request'
    | '/campaigns/archive/guide'
    | '/campaigns/create/guide'
    | '/campaigns/edit/guide'
    | '/campaigns/$campaignId/edit'
    | '/campaigns/draft/$campaignId'
    | '/campaigns/duplicate/$campaignId'
    | '/programs/$programId/edit'
  id:
    | '__root__'
    | '/_main'
    | '/_minimal'
    | '/_main/_details'
    | '/_main/_form'
    | '/_main/_list'
    | '/_minimal/info'
    | '/_main/'
    | '/_minimal/invitations/$invitationToken'
    | '/_main/_details/campaigns/$campaignId'
    | '/_main/_details/programs/$programId'
    | '/_main/_list/campaigns/archive'
    | '/_main/_form/settings/'
    | '/_main/_list/activity/'
    | '/_main/_list/api-keys/'
    | '/_main/_list/campaigns/'
    | '/_main/_list/metrics/'
    | '/_main/_list/programs/'
    | '/_main/_list/campaigns/$campaignId/activity'
    | '/_main/_list/campaigns/$campaignId/edit-requests'
    | '/_main/_list/programs/$programId/activity'
    | '/_main/_list/programs/$programId/campaigns'
    | '/_main/_details/api-keys/guide/'
    | '/_main/_details/invite/guide/'
    | '/_main/_form/campaigns/create/'
    | '/_main/_form/programs/create/'
    | '/_main/_form/campaigns/$campaignId/edit/request'
    | '/_main/_details/campaigns/archive/guide/'
    | '/_main/_details/campaigns/create/guide/'
    | '/_main/_details/campaigns/edit/guide/'
    | '/_main/_form/campaigns/$campaignId/edit/'
    | '/_main/_form/campaigns/draft/$campaignId/'
    | '/_main/_form/campaigns/duplicate/$campaignId/'
    | '/_main/_form/programs/$programId/edit/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  MainRoute: typeof MainRouteWithChildren
  MinimalRoute: typeof MinimalRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_minimal': {
      id: '/_minimal'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof MinimalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main': {
      id: '/_main'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof MainRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main/': {
      id: '/_main/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MainIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_minimal/info': {
      id: '/_minimal/info'
      path: '/info'
      fullPath: '/info'
      preLoaderRoute: typeof MinimalInfoRouteImport
      parentRoute: typeof MinimalRoute
    }
    '/_main/_list': {
      id: '/_main/_list'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof MainListRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/_form': {
      id: '/_main/_form'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof MainFormRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/_details': {
      id: '/_main/_details'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof MainDetailsRouteImport
      parentRoute: typeof MainRoute
    }
    '/_minimal/invitations/$invitationToken': {
      id: '/_minimal/invitations/$invitationToken'
      path: '/invitations/$invitationToken'
      fullPath: '/invitations/$invitationToken'
      preLoaderRoute: typeof MinimalInvitationsInvitationTokenRouteImport
      parentRoute: typeof MinimalRoute
    }
    '/_main/_list/programs/': {
      id: '/_main/_list/programs/'
      path: '/programs'
      fullPath: '/programs'
      preLoaderRoute: typeof MainListProgramsIndexRouteImport
      parentRoute: typeof MainListRoute
    }
    '/_main/_list/metrics/': {
      id: '/_main/_list/metrics/'
      path: '/metrics'
      fullPath: '/metrics'
      preLoaderRoute: typeof MainListMetricsIndexRouteImport
      parentRoute: typeof MainListRoute
    }
    '/_main/_list/campaigns/': {
      id: '/_main/_list/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof MainListCampaignsIndexRouteImport
      parentRoute: typeof MainListRoute
    }
    '/_main/_list/api-keys/': {
      id: '/_main/_list/api-keys/'
      path: '/api-keys'
      fullPath: '/api-keys'
      preLoaderRoute: typeof MainListApiKeysIndexRouteImport
      parentRoute: typeof MainListRoute
    }
    '/_main/_list/activity/': {
      id: '/_main/_list/activity/'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof MainListActivityIndexRouteImport
      parentRoute: typeof MainListRoute
    }
    '/_main/_form/settings/': {
      id: '/_main/_form/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof MainFormSettingsIndexRouteImport
      parentRoute: typeof MainFormRoute
    }
    '/_main/_list/campaigns/archive': {
      id: '/_main/_list/campaigns/archive'
      path: '/campaigns/archive'
      fullPath: '/campaigns/archive'
      preLoaderRoute: typeof MainListCampaignsArchiveRouteImport
      parentRoute: typeof MainListRoute
    }
    '/_main/_details/programs/$programId': {
      id: '/_main/_details/programs/$programId'
      path: '/programs/$programId'
      fullPath: '/programs/$programId'
      preLoaderRoute: typeof MainDetailsProgramsProgramIdRouteImport
      parentRoute: typeof MainDetailsRoute
    }
    '/_main/_details/campaigns/$campaignId': {
      id: '/_main/_details/campaigns/$campaignId'
      path: '/campaigns/$campaignId'
      fullPath: '/campaigns/$campaignId'
      preLoaderRoute: typeof MainDetailsCampaignsCampaignIdRouteImport
      parentRoute: typeof MainDetailsRoute
    }
    '/_main/_form/programs/create/': {
      id: '/_main/_form/programs/create/'
      path: '/programs/create'
      fullPath: '/programs/create'
      preLoaderRoute: typeof MainFormProgramsCreateIndexRouteImport
      parentRoute: typeof MainFormRoute
    }
    '/_main/_form/campaigns/create/': {
      id: '/_main/_form/campaigns/create/'
      path: '/campaigns/create'
      fullPath: '/campaigns/create'
      preLoaderRoute: typeof MainFormCampaignsCreateIndexRouteImport
      parentRoute: typeof MainFormRoute
    }
    '/_main/_details/invite/guide/': {
      id: '/_main/_details/invite/guide/'
      path: '/invite/guide'
      fullPath: '/invite/guide'
      preLoaderRoute: typeof MainDetailsInviteGuideIndexRouteImport
      parentRoute: typeof MainDetailsRoute
    }
    '/_main/_details/api-keys/guide/': {
      id: '/_main/_details/api-keys/guide/'
      path: '/api-keys/guide'
      fullPath: '/api-keys/guide'
      preLoaderRoute: typeof MainDetailsApiKeysGuideIndexRouteImport
      parentRoute: typeof MainDetailsRoute
    }
    '/_main/_list/programs/$programId/campaigns': {
      id: '/_main/_list/programs/$programId/campaigns'
      path: '/programs/$programId/campaigns'
      fullPath: '/programs/$programId/campaigns'
      preLoaderRoute: typeof MainListProgramsProgramIdCampaignsRouteImport
      parentRoute: typeof MainListRoute
    }
    '/_main/_list/programs/$programId/activity': {
      id: '/_main/_list/programs/$programId/activity'
      path: '/programs/$programId/activity'
      fullPath: '/programs/$programId/activity'
      preLoaderRoute: typeof MainListProgramsProgramIdActivityRouteImport
      parentRoute: typeof MainListRoute
    }
    '/_main/_list/campaigns/$campaignId/edit-requests': {
      id: '/_main/_list/campaigns/$campaignId/edit-requests'
      path: '/campaigns/$campaignId/edit-requests'
      fullPath: '/campaigns/$campaignId/edit-requests'
      preLoaderRoute: typeof MainListCampaignsCampaignIdEditRequestsRouteImport
      parentRoute: typeof MainListRoute
    }
    '/_main/_list/campaigns/$campaignId/activity': {
      id: '/_main/_list/campaigns/$campaignId/activity'
      path: '/campaigns/$campaignId/activity'
      fullPath: '/campaigns/$campaignId/activity'
      preLoaderRoute: typeof MainListCampaignsCampaignIdActivityRouteImport
      parentRoute: typeof MainListRoute
    }
    '/_main/_form/programs/$programId/edit/': {
      id: '/_main/_form/programs/$programId/edit/'
      path: '/programs/$programId/edit'
      fullPath: '/programs/$programId/edit'
      preLoaderRoute: typeof MainFormProgramsProgramIdEditIndexRouteImport
      parentRoute: typeof MainFormRoute
    }
    '/_main/_form/campaigns/duplicate/$campaignId/': {
      id: '/_main/_form/campaigns/duplicate/$campaignId/'
      path: '/campaigns/duplicate/$campaignId'
      fullPath: '/campaigns/duplicate/$campaignId'
      preLoaderRoute: typeof MainFormCampaignsDuplicateCampaignIdIndexRouteImport
      parentRoute: typeof MainFormRoute
    }
    '/_main/_form/campaigns/draft/$campaignId/': {
      id: '/_main/_form/campaigns/draft/$campaignId/'
      path: '/campaigns/draft/$campaignId'
      fullPath: '/campaigns/draft/$campaignId'
      preLoaderRoute: typeof MainFormCampaignsDraftCampaignIdIndexRouteImport
      parentRoute: typeof MainFormRoute
    }
    '/_main/_form/campaigns/$campaignId/edit/': {
      id: '/_main/_form/campaigns/$campaignId/edit/'
      path: '/campaigns/$campaignId/edit'
      fullPath: '/campaigns/$campaignId/edit'
      preLoaderRoute: typeof MainFormCampaignsCampaignIdEditIndexRouteImport
      parentRoute: typeof MainFormRoute
    }
    '/_main/_details/campaigns/edit/guide/': {
      id: '/_main/_details/campaigns/edit/guide/'
      path: '/campaigns/edit/guide'
      fullPath: '/campaigns/edit/guide'
      preLoaderRoute: typeof MainDetailsCampaignsEditGuideIndexRouteImport
      parentRoute: typeof MainDetailsRoute
    }
    '/_main/_details/campaigns/create/guide/': {
      id: '/_main/_details/campaigns/create/guide/'
      path: '/campaigns/create/guide'
      fullPath: '/campaigns/create/guide'
      preLoaderRoute: typeof MainDetailsCampaignsCreateGuideIndexRouteImport
      parentRoute: typeof MainDetailsRoute
    }
    '/_main/_details/campaigns/archive/guide/': {
      id: '/_main/_details/campaigns/archive/guide/'
      path: '/campaigns/archive/guide'
      fullPath: '/campaigns/archive/guide'
      preLoaderRoute: typeof MainDetailsCampaignsArchiveGuideIndexRouteImport
      parentRoute: typeof MainDetailsRoute
    }
    '/_main/_form/campaigns/$campaignId/edit/request': {
      id: '/_main/_form/campaigns/$campaignId/edit/request'
      path: '/campaigns/$campaignId/edit/request'
      fullPath: '/campaigns/$campaignId/edit/request'
      preLoaderRoute: typeof MainFormCampaignsCampaignIdEditRequestRouteImport
      parentRoute: typeof MainFormRoute
    }
  }
}

interface MainDetailsRouteChildren {
  MainDetailsCampaignsCampaignIdRoute: typeof MainDetailsCampaignsCampaignIdRoute
  MainDetailsProgramsProgramIdRoute: typeof MainDetailsProgramsProgramIdRoute
  MainDetailsApiKeysGuideIndexRoute: typeof MainDetailsApiKeysGuideIndexRoute
  MainDetailsInviteGuideIndexRoute: typeof MainDetailsInviteGuideIndexRoute
  MainDetailsCampaignsArchiveGuideIndexRoute: typeof MainDetailsCampaignsArchiveGuideIndexRoute
  MainDetailsCampaignsCreateGuideIndexRoute: typeof MainDetailsCampaignsCreateGuideIndexRoute
  MainDetailsCampaignsEditGuideIndexRoute: typeof MainDetailsCampaignsEditGuideIndexRoute
}

const MainDetailsRouteChildren: MainDetailsRouteChildren = {
  MainDetailsCampaignsCampaignIdRoute: MainDetailsCampaignsCampaignIdRoute,
  MainDetailsProgramsProgramIdRoute: MainDetailsProgramsProgramIdRoute,
  MainDetailsApiKeysGuideIndexRoute: MainDetailsApiKeysGuideIndexRoute,
  MainDetailsInviteGuideIndexRoute: MainDetailsInviteGuideIndexRoute,
  MainDetailsCampaignsArchiveGuideIndexRoute:
    MainDetailsCampaignsArchiveGuideIndexRoute,
  MainDetailsCampaignsCreateGuideIndexRoute:
    MainDetailsCampaignsCreateGuideIndexRoute,
  MainDetailsCampaignsEditGuideIndexRoute:
    MainDetailsCampaignsEditGuideIndexRoute,
}

const MainDetailsRouteWithChildren = MainDetailsRoute._addFileChildren(
  MainDetailsRouteChildren,
)

interface MainFormRouteChildren {
  MainFormSettingsIndexRoute: typeof MainFormSettingsIndexRoute
  MainFormCampaignsCreateIndexRoute: typeof MainFormCampaignsCreateIndexRoute
  MainFormProgramsCreateIndexRoute: typeof MainFormProgramsCreateIndexRoute
  MainFormCampaignsCampaignIdEditRequestRoute: typeof MainFormCampaignsCampaignIdEditRequestRoute
  MainFormCampaignsCampaignIdEditIndexRoute: typeof MainFormCampaignsCampaignIdEditIndexRoute
  MainFormCampaignsDraftCampaignIdIndexRoute: typeof MainFormCampaignsDraftCampaignIdIndexRoute
  MainFormCampaignsDuplicateCampaignIdIndexRoute: typeof MainFormCampaignsDuplicateCampaignIdIndexRoute
  MainFormProgramsProgramIdEditIndexRoute: typeof MainFormProgramsProgramIdEditIndexRoute
}

const MainFormRouteChildren: MainFormRouteChildren = {
  MainFormSettingsIndexRoute: MainFormSettingsIndexRoute,
  MainFormCampaignsCreateIndexRoute: MainFormCampaignsCreateIndexRoute,
  MainFormProgramsCreateIndexRoute: MainFormProgramsCreateIndexRoute,
  MainFormCampaignsCampaignIdEditRequestRoute:
    MainFormCampaignsCampaignIdEditRequestRoute,
  MainFormCampaignsCampaignIdEditIndexRoute:
    MainFormCampaignsCampaignIdEditIndexRoute,
  MainFormCampaignsDraftCampaignIdIndexRoute:
    MainFormCampaignsDraftCampaignIdIndexRoute,
  MainFormCampaignsDuplicateCampaignIdIndexRoute:
    MainFormCampaignsDuplicateCampaignIdIndexRoute,
  MainFormProgramsProgramIdEditIndexRoute:
    MainFormProgramsProgramIdEditIndexRoute,
}

const MainFormRouteWithChildren = MainFormRoute._addFileChildren(
  MainFormRouteChildren,
)

interface MainListRouteChildren {
  MainListCampaignsArchiveRoute: typeof MainListCampaignsArchiveRoute
  MainListActivityIndexRoute: typeof MainListActivityIndexRoute
  MainListApiKeysIndexRoute: typeof MainListApiKeysIndexRoute
  MainListCampaignsIndexRoute: typeof MainListCampaignsIndexRoute
  MainListMetricsIndexRoute: typeof MainListMetricsIndexRoute
  MainListProgramsIndexRoute: typeof MainListProgramsIndexRoute
  MainListCampaignsCampaignIdActivityRoute: typeof MainListCampaignsCampaignIdActivityRoute
  MainListCampaignsCampaignIdEditRequestsRoute: typeof MainListCampaignsCampaignIdEditRequestsRoute
  MainListProgramsProgramIdActivityRoute: typeof MainListProgramsProgramIdActivityRoute
  MainListProgramsProgramIdCampaignsRoute: typeof MainListProgramsProgramIdCampaignsRoute
}

const MainListRouteChildren: MainListRouteChildren = {
  MainListCampaignsArchiveRoute: MainListCampaignsArchiveRoute,
  MainListActivityIndexRoute: MainListActivityIndexRoute,
  MainListApiKeysIndexRoute: MainListApiKeysIndexRoute,
  MainListCampaignsIndexRoute: MainListCampaignsIndexRoute,
  MainListMetricsIndexRoute: MainListMetricsIndexRoute,
  MainListProgramsIndexRoute: MainListProgramsIndexRoute,
  MainListCampaignsCampaignIdActivityRoute:
    MainListCampaignsCampaignIdActivityRoute,
  MainListCampaignsCampaignIdEditRequestsRoute:
    MainListCampaignsCampaignIdEditRequestsRoute,
  MainListProgramsProgramIdActivityRoute:
    MainListProgramsProgramIdActivityRoute,
  MainListProgramsProgramIdCampaignsRoute:
    MainListProgramsProgramIdCampaignsRoute,
}

const MainListRouteWithChildren = MainListRoute._addFileChildren(
  MainListRouteChildren,
)

interface MainRouteChildren {
  MainDetailsRoute: typeof MainDetailsRouteWithChildren
  MainFormRoute: typeof MainFormRouteWithChildren
  MainListRoute: typeof MainListRouteWithChildren
  MainIndexRoute: typeof MainIndexRoute
}

const MainRouteChildren: MainRouteChildren = {
  MainDetailsRoute: MainDetailsRouteWithChildren,
  MainFormRoute: MainFormRouteWithChildren,
  MainListRoute: MainListRouteWithChildren,
  MainIndexRoute: MainIndexRoute,
}

const MainRouteWithChildren = MainRoute._addFileChildren(MainRouteChildren)

interface MinimalRouteChildren {
  MinimalInfoRoute: typeof MinimalInfoRoute
  MinimalInvitationsInvitationTokenRoute: typeof MinimalInvitationsInvitationTokenRoute
}

const MinimalRouteChildren: MinimalRouteChildren = {
  MinimalInfoRoute: MinimalInfoRoute,
  MinimalInvitationsInvitationTokenRoute:
    MinimalInvitationsInvitationTokenRoute,
}

const MinimalRouteWithChildren =
  MinimalRoute._addFileChildren(MinimalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  MainRoute: MainRouteWithChildren,
  MinimalRoute: MinimalRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
